import { reactive, toRefs, computed, provide, inject } from "@vue/composition-api";
import { bookmarks } from "../../api";
import { updateListState } from "../store_helpers";
import { state as accountState } from "./account";
import { actions as appActions } from "./app";
import router from "../../router";
import { deepClone } from "@/helpers/helpers";
import * as url from "url";

export const state = reactive({
    map: new Map(),
    list: [],
});

export const actions = {
    bookmarkEngine() {
        return true;
    },
    async fetchBookmarks(searchParams) {
        let response;
        try {
            response = await bookmarks.get(searchParams);
            updateListState(response.id, response, state.list);
            return response;
        } finally {
            state.loading = false;
        }
    },
    async postBookmark(body) {
        let response;
        try {
            response = await bookmarks.post(body);
            updateListState(response.id, response, state.list);
            return response;
        } finally {
            state.loading = false;
        }
    },
    async putBookmark(id, body) {
        let response;
        try {
            response = await bookmarks.put(id, body);
            updateListState(response.id, response, state.list);
            return response;
        } finally {
            state.loading = false;
        }
    },
    async deleteBookmark(id) {
        let response;
        try {
            response = await bookmarks.delete(id);
            updateListState(id, false, state.list);
            return response;
        } finally {
            state.loading = false;
        }
    },
    async updateBookmark(new_bookmark) {
        const bookmark = state.list.find(x => x.id === new_bookmark.id);
        Object.assign(bookmark, { ...new_bookmark });
    },
    getClientTasksBookmarkLink(client_id, bookmark) {
        let route = {};
        if (bookmark !== undefined && bookmark && bookmark.link) {
            let new_link = bookmark.link; // .replace(/^\/app/, "");
            new_link = "/clients/" + client_id + new_link.substring(new_link.indexOf("/tasks"));
            route = { path: new_link };
        } else {
            route = { name: "client_profile_tasks", params: { id: client_id }};
        }

        return route
    },
    navigate_client_tasks_bookmark(client_id, bookmark) {
        let route = {};
        if (bookmark !== undefined && bookmark && bookmark.link) {
            let new_link = bookmark.link; // .replace(/^\/app/, "");
            new_link = "/clients/" + client_id + new_link.substring(new_link.indexOf("/tasks"));
            route = { path: new_link };
        } else {
            route = { name: "client_profile_tasks", params: { id: client_id }};
        }
        router.push(route);
    },
    async navigate_report_default_route(params) {
        let queryParameters = deepClone({
            dates_list: [
                new Date().toISOString().split("T")[0],
                new Date().toISOString().split("T")[0],
                "d_0",
                "d_0"
            ],
            person_id_list: [],
            client_id_list: [],
            topic_id_list: [],
            task_status: [],
            keyword: "",
            columns: [],
            groupBy: "client;topic",
            view: "summary",
            ...(params && params)
        })

        appActions.navigateReload({
            name: 'report',
            query: queryParameters
        })
    },
};

export const getters = {
    bookmarks: computed(() => state.list),
    bookmarks_by_type: type => computed(() => state.list.filter(x => x.type === type)),
    client_bookmarks: computed(() => state.list.filter(x => x.type === "client")),
    client_tasks_bookmarks: computed(() => state.list.filter(x => x.type === "client_tasks")),
    dashboard_tasks_bookmarks: computed(() => state.list.filter(x => x.type === "dashboard_tasks")),
    dashboard_search_bookmarks: computed(() => state.list.filter(x => x.type === "dashboard_search")),
    calendar_bookmarks: computed(() => state.list.filter(x => x.type === "calendar")),
    links: computed(() => state.list.filter(x => x.type === "link")),

    link: id => computed(() => state.list.filter(x => x.type === "link" && x.id === Number(id))),
    dashboard_bookmark_route: computed(() => {
        let bookmark = getters.dashboard_tasks_bookmarks.value.find(
            c => Number(c.name) === Number(accountState.current_account.id)
        );
        if (bookmark) {
            let new_link = bookmark.link.replace(/^\/app/, "");
            if (new_link === "/" || new_link.indexOf("?ukuwinversion=") >= 0) return false;
            return { path: new_link };
        } else {
            return false;
        }
    })
};

export const key = Symbol("BookmarkModule");

export const provideBookmark = () =>
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });

export default () => inject(key);
